/** Existing rule API; school-defined periods always use saved Time Periods. */
import { getDateRangeForTimeframe } from './dateHelpers.js';
import { needsSchoolRulePeriod } from '../../domain/schoolRulePeriods.js';

export function getDateRangeForRule(timeframe, timeCount = 1, schoolId = null, options = {}) {
  const { referenceDate = new Date(), timeZone = null } = options;
  return getDateRangeForTimeframe(timeframe, timeCount, schoolId, referenceDate, timeZone);
}

export function shouldUseCustomPeriods(rule, timeframe) {
  return needsSchoolRulePeriod(timeframe || rule?.timeframe);
}

export function getDateRangeForRuleWithDetection(rule, timeframe, timeCount = 1, schoolId = null, options = {}) {
  return getDateRangeForRule(timeframe || rule?.timeframe, timeCount, schoolId, options);
}
